import type { GovernmentApplicationAggregateTableRowData } from '@/features/labor-core/-components/government-application-aggregate/types';

import type { GovernmentApplicationPackageInstancesResponse } from './api';

type GovInstanceRow =
  GovernmentApplicationPackageInstancesResponse['items'][number];

export function mapGovernmentApplicationInstanceToTableRowData(
  row: GovInstanceRow,
): GovernmentApplicationAggregateTableRowData {
  return {
    id: row.id,
    completedOperationStepCount: row.completedOperationStepCount,
    totalOperationStepCount: row.totalOperationStepCount,
    target: {
      targetType: row.target.targetType,
      targetId: row.target.targetId,
      targetName: row.target.targetName,
      targetAvatarUrl: row.target.targetAvatarUrl,
    },
    anchorDate: row.anchorDate,
    tag: row.tag ?? null,
    columns: row.columns,
  };
}
